import { render, staticRenderFns } from "./textarea_input.vue?vue&type=template&id=3fabd8d8&lang=pug"
import script from "./textarea_input.vue?vue&type=script&lang=js"
export * from "./textarea_input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports